import { useMemo } from 'react';
import { RequestScope } from '../../../actions/api';
import { SurveyScope, ScopeGroups } from '@g17eco/types/surveyCommon';
import { MetricGroup } from '../../../types/metricGroup';
import { CustomSelectOption } from '@features/select-packs';
import { getRequestScopeExtended } from '../../../utils/requestScope';
import { mergeScopes } from '../../../utils/dataShare';

interface InitiativeRequestScopes {
  metricGroups: MetricGroup[];
  initiativeCombinedScope: SurveyScope | undefined;
  requestScopes: RequestScope[];
}

export const useInitiativeRequestScopes = ({
  metricGroups,
  initiativeCombinedScope,
  requestScopes,
}: InitiativeRequestScopes) => {
  const initiativeRequestScopes = useMemo(() => {
    if (!initiativeCombinedScope) {
      return [];
    }

    const groupOptions = metricGroups.reduce((acc, cur) => {
      acc[cur._id] = { name: cur.groupName, src: cur.groupData?.icon };
      return acc;
    }, {} as CustomSelectOption);

    // filter out packs in initiative combined scope and current data share
    const allScopes = getRequestScopeExtended(groupOptions);
    const mergedScope = mergeScopes(initiativeCombinedScope, requestScopes);
    return allScopes.filter((scope) => {
      return mergedScope[scope.scopeType as ScopeGroups].includes(scope.code);
    });
  }, [metricGroups, initiativeCombinedScope, requestScopes]);

  return initiativeRequestScopes;
};
